
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import AddPlaces from "./AddPlaces";
import PrivacyPolicy from "./PrivacyPolicy"
import TermsOfService from "./TermsOfService";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/addplaces" element={<AddPlaces />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/termsofservice" element={<TermsOfService />} />
    </Routes>
  );
}

export default App;
